<div class="salon-details">
  <div class="container-md px-0 mx-0 mx-md-auto mt-sm-4">
    <div class="salon-image-container">
      <div class="salon-image bg-white"
           [ngStyle]="{'background-image': 'url(' + imageUrl + ')'}">
      </div>
      <div class="salon-logo shadow-sm bg-white"
           [ngStyle]="{'background-image': 'url(' + logoUrl + ')'}">
      </div>
    </div>
  </div>

  <div class="container-md">
    <div class="row mt-5">
      <div class="col-12">
        <h1 class="m-0 h2 fw-bolder">
          {{ salonDetails.name }}
        </h1>
        <ng-template #reviewsHeader></ng-template>
        <app-badge-gifts *ngIf="salonDetails.allowsGifts"
                         class="mt-4">
          <app-badge-gifts-description>
            <span>{{ 'SHARED.BADGE-GIFTS.DESCRIPTION' | translate }}</span>
          </app-badge-gifts-description>
        </app-badge-gifts>
      </div>
    </div>
  </div>

  <div class="container-md my-4">
    <div class="row">
      <div class="col-12">
        <div class="fw-bold">
          {{ formattedSalonDepartments }}
        </div>
      </div>
      <div class="col-12">
        <div class="salon-address text-secondary mt-1">
          {{ formattedSalonAddress }}
        </div>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <a [attr.href]="googleMapsUrl"
             target="_blank"
             rel="noopener noreferrer"
             (click)="$event.stopPropagation()"
             class="d-inline-flex align-items-center text-primary justify-self-end">
            <span [translate]="'SALON-DETAILS.SHOW-ON-MAP'"></span>
            <i-feather name="external-link"
                       class="sm ms-1"></i-feather>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="container-md px-0 mx-0 mx-md-auto mb-4">
    <h2 class="visually-hidden"
        [translate]="'SALON-DETAILS.BOOK-YOUR-APPOINTMENT'"></h2>
    <app-scroll-to-category class="mb-4"
                            [treatmentCategories]="treatmentCategories"></app-scroll-to-category>

    <div class="treatment-category-container"
         *ngFor="let category of treatmentCategories; let j = index">
      <app-treatment-category [category]="category"
                              [isOnlineBookingTurnedOn]="true"
                              [salon]="salonDetails"
                              [isMultipleTreatmentsBookingTurnedOn]="isMultipleTreatmentsBookingTurnedOn"
                              (treatmentBookClicked)="bookTreatment($event)"
                              (treatmentShowDescriptionClicked)="onTreatmentShowDescriptionClick($event)"
                              (multipleTreatmentsClicked)="addToMultipleTreatmentsArray($event, selectedTreatment)"
                              [categoryIndex]="j"
                              data-bs-theme="blue">
      </app-treatment-category>
    </div>
  </div>

  <ng-template #reviewsSection></ng-template>

  <div class="container-md">
    <div class="row mb-5">
      <div class="col-12 col-md-8">
        <div class="salon-description mt-4">
          <h2 class="h4 text-dark fw-bold"
              [translate]="'SALON-DETAILS.ABOUT-SALON-HEADER'"
              [translateParams]="{departments: formattedSalonDepartmentsForAboutSalon,
                               salonName: salonDetails.name,
                               city: salonDetails.city}"></h2>
          <p class="m-0"
             [translate]="'SALON-DETAILS.ABOUT-SALON'"
             [translateParams]="{departments: formattedSalonDepartmentsForAboutSalon,
                             salonName: salonDetails.name,
                             city: salonDetails.city}"></p>
        </div>
        <div class="salon-description mt-4"
             *ngIf="salonDetails.description">
          <p class="m-0 text-break">{{ salonDetails.description }}</p>
        </div>
      </div>

      <div class="col-12 col-md-4"
           *ngIf="salonDetails">
        <div class="salon-social-links mt-4">
          <a href="{{ salonDetails.website }}"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-link text-dark py-2 ps-0 pe-3 pe-md-2 border-0"
             title="{{ salonDetails.website }}"
             *ngIf="salonDetails.website">
            <i-feather name="home"></i-feather>
            <span class="visually-hidden">Website</span>
          </a>

          <a href="{{ salonDetails.facebook }}"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-link text-dark py-2 ps-0 pe-3 pe-md-2 border-0"
             title="{{ salonDetails.facebook }}"
             *ngIf="salonDetails.facebook">
            <i-feather name="facebook"></i-feather>
            <span class="visually-hidden">Facebook</span>
          </a>

          <a href="{{ salonDetails.twitter }}"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-link text-dark py-2 ps-0 pe-3 pe-md-2 border-0"
             title="{{ salonDetails.twitter }}"
             *ngIf="salonDetails.twitter">
            <i-feather name="twitter"></i-feather>
            <span class="visually-hidden">Twitter</span>
          </a>

          <a href="{{ salonDetails.instagram }}"
             target="_blank"
             rel="noopener noreferrer"
             class="btn btn-link text-dark py-2 ps-0 pe-3 pe-md-2 border-0"
             title="{{ salonDetails.instagram }}"
             *ngIf="salonDetails.instagram">
            <i-feather name="instagram"></i-feather>
            <span class="visually-hidden">Instagram</span>
          </a>
        </div>
        <app-salon-details-opening-hours [schedule]="salonDetails.schedule"
                                         class="mt-4">
        </app-salon-details-opening-hours>
      </div>
    </div>
  </div>
  <app-multiple-treatments-basket *ngIf="selectedTreatments.length > 0"
                                  [@inOutAnimation]
                                  class="d-flex justify-content-center sticky-bottom"
                                  [selectedTreatments]="selectedTreatments"
                                  (bookMultpleTreatmentsClicked)="bookTreatment($event)">
  </app-multiple-treatments-basket>
</div>
